export default __webpack_public_path__ + "static/media/regulatory--one-way-straight--g1.47ea933f.png";